import axios from "axios";

const BACKEND_API = 'http://localhost:3001';
//const BACKEND_API = 'https://lexi-odwcf2od6a-oa.a.run.app';

const deduplicateArticles = (articles) => {
  const uniqueArticles = new Set();
  const deduplicatedArticles = [];
  console.log(`Deduplicating ${articles.length} articles`);

  articles.forEach((article) => {
    const articleId = `${article.title}`;
    if (!uniqueArticles.has(articleId)) { 
      uniqueArticles.add(articleId);
      deduplicatedArticles.push(article);
    } else {
      console.log(`Deduplicated article detected: ${article.title}`);
    }
  });

  console.log(`Unique articles: ${deduplicatedArticles.length}`);
  return deduplicatedArticles;
};


export const retrieveNews = async (keywords, language, user_id, consume, setGlobalError, isLoading) => {
  let url = `${BACKEND_API}/get-news/`;
  isLoading(true);
  axios
    .get(url, {
      params: {
        q: keywords,
        language: language,
        user_id: user_id,
      },
    })
    .then(function (r1) {
      consume(deduplicateArticles(r1.data));
      isLoading(false);
    }).catch((e)=>{
      setGlobalError(e.message);
      isLoading(false);
    });
};

export const aiRequestHandler = async (words, text, level, language, user_id, setLoading, consume) => {
  let url = `${BACKEND_API}/inject/`;
  setLoading(true);

  axios
    .post(url, {
      text: text,
      words: words,
      level: level,
      language: language,
      user_id: user_id,
    })
    .then(function (r1) {
      consume(r1.data);
    })
    .finally(() => {
      setLoading(false);
    });
};

export const getDefinition = async (word, language, user_id) => {
  let url = `${BACKEND_API}/definition/`;
  return axios.get(url, { params: { word: word, language: language, user_id: user_id } });
};

export const incrementWord = async (wordId) => {
  let url = `${BACKEND_API}/increment/`;
  axios.post(url, { wordId: wordId });
};


export const getWords = async (user_id) => {
  let url = `${BACKEND_API}/words/`;
  return axios.get(url, { params: { user_id: user_id } });
};

export const addWord = async (word, user_id) => {
  let url = `${BACKEND_API}/add-word/`;
  return axios.post(url, { word: word, user_id: user_id });
};

export const deleteWord = async (wordId, user_id, word) => {
  let url = `${BACKEND_API}/delete-word/`;
  return axios.post(url, { wordId: wordId, user_id: user_id, word: word });
};

export const getTopics = async (user_id) => {
  let url = `${BACKEND_API}/topics/`;
  return axios.get(url, { params: { user_id: user_id } });
};

export const addTopic = async (topic, user_id) => {
  let url = `${BACKEND_API}/add-topic/`;
  return axios.post(url, { topic: topic, user_id: user_id });
};

export const deleteTopic = async (topicId, user_id, topicName) => {
  let url = `${BACKEND_API}/delete-topic/`;
  return axios.post(url, { topicId: topicId, user_id: user_id, topic_name: topicName });
};